<template>
  <div class="emojiDialog">
    <ul ref="emojiPickerListRef" class="emojiDialogList">
      <li
        v-for="(childrenItem, childrenIndex) in currentEmojiList"
        :key="childrenIndex"
        class="emojiDialogList-item"
        @click="select(childrenItem, childrenIndex)"
      >
        <img
          class="emoji"
          :src="BASIC_EMOJI_URL + BASIC_EMOJI_URL_MAPPING[childrenItem]"
        >
      </li>
    </ul>
    <div class="sendButtonContainer">
      <div class="sendButton" @click="sendMessage">
        {{ TUITranslateService.t("发送") }}
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import vue from '../../../../adapter-vue';
import { IEmojiGroupList } from '../../../../interface';
const { ref, onMounted, onUnmounted } = vue;
import {
  TUIStore,
  StoreName,
  IConversationModel,
  TUITranslateService,
} from '../../../../@aidesk/uikit-engine';
import {
  EMOJI_GROUP_LIST,
  BASIC_EMOJI_URL_MAPPING,
  convertKeyToEmojiName,
  BASIC_EMOJI_URL,
  filterEmojisInNonChineseEnv,
} from '../../emoji-config';

const emits = defineEmits(['insertEmoji', 'onClose', 'sendMessage']);
const list = ref<IEmojiGroupList>(initEmojiList());
const currentConversation = ref();
const emojiPickerListRef = ref();
const currentEmojiList = ref<string[]>(list?.value[0]?.list);

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
  currentEmojiList.value = filterEmojisInNonChineseEnv(list.value[0].list);
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
});

const select = (item: any, index: number) => {
  const options: any = {
    emoji: { key: item, name: convertKeyToEmojiName(item) },
    type: 'basic',
    url : BASIC_EMOJI_URL + BASIC_EMOJI_URL_MAPPING[item],
  };
  emits('insertEmoji', options);
};

function sendMessage(){
    emits('sendMessage');
}

function onCurrentConversationUpdate(conversation: IConversationModel) {
  currentConversation.value = conversation;
}

function initEmojiList() {
  return EMOJI_GROUP_LIST;
}
</script>
<style lang="scss" scoped>
.emojiDialog {
    height: 25vh;
    position:relative;
    .emojiDialogList {
        width: 100%;
        display:flex;
        flex-wrap: wrap;
        overflow-y: auto;
        margin:2px;
        justify-content: space-between;
        .emojiDialogList-item {
            cursor: pointer;
            padding: 5px;
            .emoji {
                width: 30px;
        height: 30px;
            }
        }
    }
    .emojiDialogList::after{
        content: "";
        display: block;
        flex: 1 1 auto;
    }
}
.sendButtonContainer {
    display:flex;
    justify-content: flex-end;
    width: 100%;
    height: 45px;
    margin-top:5px;
    .sendButton {
        background-color: #1C66E5;
        color: white;
        border-radius: 5px;
        margin-right: 10px;
        align-self: center;
        padding: 5px 10px;
    }
    
}
</style>